export default __webpack_public_path__ + "static/media/like.347a94bf.svg";